import React from "react";
import FlatButton from "material-ui/FlatButton";
import ModifyIcon from "material-ui/svg-icons/content/create";
import PropTypes from "prop-types";
import NoticeWriteDialog from "./NoticeWriteDialog";
import "react-quill/dist/quill.snow.css";
import "react-quill/dist/quill.bubble.css";
import "react-quill/dist/quill.core.css";

export default class NoticeModifyDialog extends NoticeWriteDialog {
    state = {
        open: false,
        title:'',
        msg:'',
        isPublic:1,
        noticeKey:this.props.noticeKey
    };

    init(){
        this.setState({
            title:this.props.title,
            msg:this.props.msg,
            isPublic:this.props.isPublic,
            noticeKey:this.props.noticeKey
        });
    }

    submitHandler(){
        this.props.onSubmit({
            title:this.state.title,
            msg:this.state.msg,
            isPublic:this.state.isPublic,
            noticeKey:this.props.noticeKey
        });
        this.setState({open:false});
    }

    generateBtn(){
        return (<FlatButton
            label="수정"
            icon={<ModifyIcon />}
            onTouchTap={this.handleOpen}
        />)
    }

}

NoticeWriteDialog.propTypes = {
    campaignId:PropTypes.number.isRequired,
    onSubmit:PropTypes.func.isRequired
}


// WEBPACK FOOTER //
// ./src/container/campaign/component/NoticeModifyDialog.js